import { Result } from "antd";
import i18n from "@/utils/i18n";
export function PendingApprovalState() {
  return (
    <Result
      status="info"
      title={i18n.t("pendingApprovalState.title")}
      subTitle={i18n.t("pendingApprovalState.subTitle")}
    />
  );
}
